import i18n from 'src/i18n';
const configTable = () => {
    const tableColumns = [
        {
            prop: 'code',
            label: i18n.t('common_words.code'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'name',
            label: i18n.t('common_words.activity'),
            align: 'center',
            minWidth: 220,
            sortable: true,
        },
        {
            prop: 'group_name',
            label: i18n.t('labor.group_activities'),
            align: 'center',
            sortable: true,
            minWidth: 160,
        },
        {
            prop: 'homologated_code',
            label: i18n.t('common_words.code_homologated'),
            align: 'center',
            sortable: true,
            show: false,
        },
        {
            prop: 'cost_center',
            label: i18n.t('common_words.cost_center'),
            align: 'center',
            sortable: true,
            show: false,
        },
        {
            prop: 'catch_type',
            label: i18n.t('common_words.type_capture'),
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return row.catch_type;   
              },
        },
        {
            prop: 'minimum',
            label: i18n.t('common_words.minimum'),
            align: 'center',
            sortable: true,
            show: false,
            formatter: (row) => {
                return parseFloat(row.minimum);   
              },
        },
        {
            prop: 'maximum',
            label: i18n.t('common_words.maximum'),
            align: 'center',
            sortable: true,
            show: false,
            formatter: (row) => {
                return parseFloat(row.maximum);
            },
        },
        {
            prop: 'unit_production_name',
            label: i18n.t('common_words.payment_unit'),
            align: 'center',
            sortable: true,
            minWidth: 140,
        },
        {
            prop: 'unit_payment_name',
            label: i18n.t('common_words.production_unit'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'aditional_activity',
            label: i18n.t('labor.additional_activity'),
            align: 'center',
            sortable: true,
            show: false, 
            formatter: (row) => {
                return row.aditional_activity
                    ?
                    i18n.t('common_words.yes')
                    : i18n.t('common_words.no')
            },
        },
        {
            prop: 'group_activities',
            label: i18n.t('labor.group_activities'),
            align: 'center',
            sortable: true,
            show: false,
            formatter: (row) => {
                return row.group_activities
                    ?
                    i18n.t('common_words.yes')
                    : i18n.t('common_words.no')
            },
        },
        {
            prop: 'assist_control',
            label: i18n.t('labor.assist_control'),
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return row.assist_control
                    ?
                    i18n.t('common_words.yes')
                    : i18n.t('common_words.no')
            },
        },
    ];
    return { tableColumns };
};

export default configTable;